import styled from 'styled-components';
import { Label } from '../../../components/uielements';
import { palette } from 'styled-theme';

export const Main = styled.main`
  display: grid;
  grid-template-columns: 1fr 1fr;
  height: 100vh;
  width: 100vw;
`;

export const SectionLeft = styled.section`
  background-color: ${palette('background', 0)};
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 30px;
  padding: 120px;
  padding-top: 180px;
  overflow-y: scroll;
`;

export const SectionRight = styled.section`
  background-image: url(${(props) => props.bg});
  transition: background-image 0.5s ease-in-out;
  background-size: cover;
  background-position: center;
`;

export const Heading = styled(Label).attrs({ size: 'header2', color: 'black', weight: 'bold' })`
  text-transform: uppercase;
`;

export const SubHeading = styled(Label).attrs({ size: 'normal', color: 'black' })``;

export const PromptList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
`;

export const PromptItem = styled.li`
  font-size: 14px;
  color: white;
  background-color: #3173da;
  padding: 0.75rem 1.5rem;
  border-radius: 0.7rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  text-align: center;
  list-style: none;
  transition:
    background-color 0.3s ease,
    box-shadow 0.3s ease;
  white-space: nowrap;
  width: auto;
  &:focus {
    outline: 2px solid #4a90e2;
    outline-offset: 2px;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
  margin-top: 1rem;
`;

export const OptionButton = styled.button`
  background-color: #41e4c9;
  color: white;
  padding: 10px;
  cursor: pointer;
  font-family: 'JetBrains Mono Regular';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: -0.18px;
  border: none;
`;

export const Spinner = styled.div`
  width: 1.25rem;
  height: 1.25rem;
  border: 3px solid #629dfb;
  border-radius: 50%;
  border-top: 3px solid #000;
  animation: spin 1s linear infinite;
  margin-right: 10px;
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const ErrorMessage = styled.div`
  color: #d32f2f;
  background-color: #ffebee;
  padding: 8px;
  margin: 8px 0;
  border-radius: 4px;
`;
